module.exports = __webpack_public_path__ + "static/media/start-screen-logo.2b82449f.png";